import { render, staticRenderFns } from "./MainLayout.vue?vue&type=template&id=6093b89c"
import script from "./mainLayout.ts?vue&type=script&lang=ts&external"
export * from "./mainLayout.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6093b89c')) {
      api.createRecord('6093b89c', component.options)
    } else {
      api.reload('6093b89c', component.options)
    }
    module.hot.accept("./MainLayout.vue?vue&type=template&id=6093b89c", function () {
      api.rerender('6093b89c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/layouts/MainLayout.vue"
export default component.exports